export const userVal = {
  inspector: {
    element: "select",
    value: "",
    label: false,
    labelText: "",
    containerConfig: {},
    config: {
      name: "inspector",
      type: "text",
      placeholder: "",
      options: [],
    },
    validation: {
      required: false,
    },
    valid: false,
    touched: false,
    validationMessage: "",
  },
};



// WEBPACK FOOTER //
// ./src/components/JourneyPlan/JourneyPlanList/variables.js